<!--
 * @Description: lbImage
 * @Author: xiao li
 * @Date: 2021-07-04 00:16:14
 * @LastEditTime: 2024-01-19 14:49:43
 * @LastEditors: DXV-RGWU-TUFH-RFCY-IEGMYY
-->
<template>
  <el-form
    @submit.native.prevent
    :model="info"
    ref="info"
    label-width="150px"
    size="mini"
  >
    <div class="space-sm"></div>
    <lb-classify-title title="基础信息"></lb-classify-title>
    <el-form-item label="服务名称" prop="title">
      {{ info.title }}
    </el-form-item>
    <el-form-item label="副标题" prop="sub_title" v-if="!info.is_add">
      {{ info.sub_title }}
    </el-form-item>
    <el-form-item label="所属分类" prop="cate_id">
      <span v-for="(item, index) in info.cate_name" :key="index">
        {{ index == 0 ? '' : '、' }}{{ item }}
      </span>
      <span v-if="info.cate_name && info.cate_name.length === 0">暂未设置</span>
    </el-form-item>
    <el-form-item label="服务类型" prop="send_type">
      {{
        info.is_door && info.is_store
          ? '上门、到店'
          : info.is_door
          ? '上门'
          : '到店'
      }}
    </el-form-item>
    <el-form-item label="封面图" prop="cover">
      <div class="flex-warp mt-sm mb-sm">
        <lb-image
          :src="item.url"
          :isLook="true"
          class="lb-image-item"
          v-for="(item, index) in info.cover"
          :key="index"
        />
      </div>
    </el-form-item>
    <el-form-item label="轮播图" prop="imgs" v-if="!info.is_add">
      <div class="flex-warp mt-sm mb-sm">
        <lb-image
          :src="item.url"
          :isLook="true"
          class="lb-image-item"
          v-for="(item, index) in info.imgs"
          :key="index"
        />
      </div>
    </el-form-item>
    <!-- <el-form-item label="服务原价" prop="init_price">
      ¥{{ info.init_price }}
    </el-form-item> -->
    <el-form-item label="服务价格" prop="price">
      ¥{{ info.price }}
    </el-form-item>
    <el-form-item label="物料费" prop="material_price">
      ¥{{ info.material_price }}
    </el-form-item>
    <el-form-item label="虚拟销售量" prop="sale">
      {{ info.sale }}人选择 （{{
        !info.is_add && info.show_salenum ? '不' : ''
      }}显示实际销量和虚拟销量）
    </el-form-item>
    <el-form-item label="服务时长" prop="time_long">
      {{ info.time_long }}分钟
    </el-form-item>
    <block
      v-if="
        reseller_cash_type === 1 &&
        ((routesItem.userInfo.is_admin &&
          (!info.admin_id || (info.admin_id && info.reseller_auth))) ||
          (!routesItem.userInfo.is_admin && routesItem.auth.reseller_auth))
      "
    >
      <el-form-item label="一级分销提成" prop="com_balance">
        {{ info.com_balance ? `${info.com_balance}%` : `-` }}
      </el-form-item>
      <el-form-item label="二级分销提成" prop="level_balance">
        {{ info.level_balance ? `${info.level_balance}%` : `-` }}
      </el-form-item>
    </block>
    <el-form-item label="排序值" prop="top">
      {{ info.top }}
    </el-form-item>
    <block v-if="routesItem.auth.member">
      <div class="space-lg"></div>
      <lb-classify-title title="会员信息"></lb-classify-title>
      <el-form-item label="会员专享" prop="member_service">
        {{ info.member_service ? '开启' : '关闭' }}
      </el-form-item>
      <el-form-item
        label="指定会员等级专享"
        prop="service_level"
        v-if="info.member_service"
      >
        <span v-for="(item, index) in info.member_service_level" :key="index">
          {{ index === 0 ? '' : '、' }}{{ item.title }}
        </span>
      </el-form-item>
    </block>
    <div class="space-lg"></div>
    <lb-classify-title
      title="其他信息"
      v-if="
        (info.is_add && info.coach && info.coach.length > 0) || !info.is_add
      "
    ></lb-classify-title>

    <el-form-item label="项目介绍" prop="introduce" v-if="!info.is_add">
      <div
        class="fill-body mb-md radius-15"
        style="padding: 15px; max-height: 400px; overflow: auto"
        v-html="info.introduce"
      ></div>
    </el-form-item>
    <el-form-item label="禁忌说明" prop="explain" v-if="!info.is_add">
      <div
        class="fill-body mb-md radius-15"
        style="padding: 15px; max-height: 400px; overflow: auto"
        v-html="info.explain"
      ></div>
    </el-form-item>
    <el-form-item label="下单须知" prop="notice" v-if="!info.is_add">
      <div
        class="fill-body mb-md radius-15"
        style="padding: 15px; max-height: 400px; overflow: auto"
        v-html="info.notice"
      ></div>
    </el-form-item>
    <el-form-item
      :label="'关联' + $t('action.attendantName')"
      prop="coach"
      v-if="info.coach && info.coach.length > 0"
    >
      <el-table
        :data="info.coach"
        :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
        :height="info.coach.length > 5 ? 550 : ''"
        style="width: 100%"
      >
        <el-table-column prop="id" label="ID"></el-table-column>
        <el-table-column prop="work_img" label="头像">
          <template slot-scope="scope">
            <lb-image :src="scope.row.work_img" />
          </template>
        </el-table-column>
        <el-table-column prop="coach_name" label="姓名"></el-table-column>
        <el-table-column prop="admin_name" label="所属代理商"></el-table-column>
        <el-table-column prop="price" label="价格">
          <template slot-scope="scope"> ¥{{ scope.row.price }} </template>
        </el-table-column>
      </el-table>
    </el-form-item>
    <el-form-item>
      <div class="space-lg"></div>
      <lb-button @click="$router.back(-1)">{{ $t('action.back') }}</lb-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
export default {
  name: 'lbServiceInfo',
  props: {
    info: {
      type: Object,
      default () {
        return {}
      }
    },
    reseller_cash_type: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState({
      routesItem: state => state.routes
    })
  },
  methods: {
  },
  filters: {
    handleTime (val, type) {
      let time = type === 1 ? moment(val * 1000).format('YYYY-MM-DD') : type === 2 ? moment(val * 1000).format('HH:mm:ss') : moment(val * 1000).format('YYYY-MM-DD HH:mm:ss')
      return time
    },
    handleStartEndTime (val) {
      let text = ''
      let { start_time: start, end_time: end } = val
      let day = moment(Date.now()).format('YYYY-MM-DD')
      if (start && end && (moment(`${day} ${end}`).unix() <= moment(`${day} ${start}`).unix())) {
        text = '次日'
      }
      return text
    },
    handleFileName (url) {
      let text = '暂未设置'
      if (url) {
        text = url.substring(url.lastIndexOf('/') + 1)
      }
      return text
    },
    handleName (id, list) {
      let text = '暂未设置'
      let arr = list.filter(item => {
        return item.id === id
      })
      return arr && arr.length > 0 ? arr[0].title : text
    },
    handleBalanceTime (time) {
      let text = '暂未设置'
      if (time && time.length > 0) {
        text = moment(time[0]).format('YYYY-MM-DD') + ' 至 ' + moment(time[1]).format('YYYY-MM-DD')
      }
      return text
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form-item {
  color: #888;
}
.lb-image-item {
  width: 60px;
  height: 60px;
  margin-left: 10px;
}
.lb-image-item:nth-child(1) {
  margin-left: 0;
}

.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/basics/lbServiceInfo.vue